import { Button, Header, Icon } from "semantic-ui-react";
import AddAttendee from "./AddAttendee";
import PageModal from "../PageModal/PageModal";
import { useState } from "react";

const RemoteEvent = (props) => {
  const {
    selectedJob,
    loginContext,
    handleUpdateJob,
    setSelectedJob,
    isAddAttendee,
    setAddAttendee,
    updating,
  } = props;
  const [newAttendee, setNewAttendee] = useState({
    guestName: "",
    email: "",
    group: "",
  });

  const Attendees = () => {
    const array = JSON.parse(selectedJob.meeting);
    return array.map((item, index) => {
      return (
        <Header as="h4">
          {item.guestName}
          <Header.Subheader>{item.email}</Header.Subheader>
          <Header.Subheader>{item.group}</Header.Subheader>
          {loginContext.email === item.email && (
            <Header.Subheader>
              https://app.stenexus.com/meeting/?key={item.key}
              <Icon
                className="custom-button"
                style={{ marginLeft: "5px" }}
                name="external alternate"
                color="blue"
                onClick={() =>
                  window.open(
                    `https://app.stenexus.com/meeting/?key=${item.key}`
                  )
                }
              />
            </Header.Subheader>
          )}
        </Header>
      );
    });
  };
  return (
    <div>
      <Header>Attendees</Header>
      <Button
        content="Add Attendee"
        icon="plus"
        size="large"
        positive
        onClick={() => setAddAttendee(!isAddAttendee)}
      />
      <PageModal
        open={isAddAttendee}
        setOpen={setAddAttendee}
        heading="Add Attendee"
        styles={{ minHeight: "300px" }}
        resetState={() =>
          setNewAttendee({ guestName: "", email: "", group: "" })
        }
        noScroll
        actions={
          <Button
            size="large"
            positive
            content="Save"
            onClick={() => handleUpdateJob()}
            disabled={updating}
            loading={updating}
          />
        }
      >
        <AddAttendee
          newAttendee={newAttendee}
          setNewAttendee={setNewAttendee}
          setSelectedJob={setSelectedJob}
          selectedJob={selectedJob}
        />
      </PageModal>
      <Attendees />
    </div>
  );
};

export default RemoteEvent;
